import { CONTRACT_ACTION } from 'model/constants/actionConstants';

const initBuyer = {
  loading: false,
  data: null,
};

const initProduct = {
  loading: false,
  data: null,
};

const initFee = {
  loading: false,
  data: null,
};

const initDoc = {
  loading: false,
  reportYear: null,
  proposal: null,
};

const invoice = {
  loading: false,
  data: null,
};

const initState = {
  loading: false,
  contracts: null,
  currentContract: null,
  buyer: initBuyer,
  product: initProduct,
  fee: initFee,
  document: initDoc,
  invoice,
  benefits: null,
  benefitsContract: null,
  popupLoyalty: true,
};

export default (state = initState, action) => {
  switch (action.type) {
    case CONTRACT_ACTION.START_FETCHING:
      return { ...state, loading: true };
    case CONTRACT_ACTION.STOP_FETCHING:
      return { ...state, loading: false };
    case CONTRACT_ACTION.START_FETCHING_BUYER:
      return { ...state, buyer: { ...state.buyer, loading: true } };
    case CONTRACT_ACTION.STOP_FETCHING_BUYER:
      return { ...state, buyer: { ...state.buyer, loading: false } };
    case CONTRACT_ACTION.START_FETCHING_PRODUCT:
      return { ...state, product: { ...state.product, loading: true } };
    case CONTRACT_ACTION.STOP_FETCHING_PRODUCT:
      return { ...state, product: { ...state.product, loading: false } };
    case CONTRACT_ACTION.START_FETCHING_FEE:
      return { ...state, fee: { ...state.fee, loading: true } };
    case CONTRACT_ACTION.STOP_FETCHING_FEE:
      return { ...state, fee: { ...state.fee, loading: false } };
    case CONTRACT_ACTION.START_FETCHING_DOCUMENT:
      return { ...state, document: { ...state.document, loading: true } };
    case CONTRACT_ACTION.STOP_FETCHING_DOCUMENT:
      return { ...state, document: { ...state.document, loading: false } };
    case CONTRACT_ACTION.START_FETCHING_INVOICE:
      return { ...state, invoice: { ...state.invoice, loading: true } };
    case CONTRACT_ACTION.STOP_FETCHING_INVOICE:
      return { ...state, invoice: { ...state.invoice, loading: false } };

    case CONTRACT_ACTION.SET_CONTRACTS:
      return { ...state, contracts: action.payload };
    case CONTRACT_ACTION.SET_CURRENT_CONTRACT:
      return { ...state, currentContract: action.payload };
    case CONTRACT_ACTION.SET_BUYER:
      return { ...state, buyer: { ...state.buyer, data: action.payload } };
    case CONTRACT_ACTION.SET_PRODUCT:
      return { ...state, product: { ...state.product, data: action.payload } };
    case CONTRACT_ACTION.SET_FEE:
      return { ...state, fee: { ...state.fee, data: action.payload } };
    case CONTRACT_ACTION.SET_INVOICE:
      return { ...state, invoice: { ...state.invoice, data: action.payload } };
    case CONTRACT_ACTION.RESET:
      return { ...initState };
    case CONTRACT_ACTION.RESET_A_CONTRACT:
      return {
        ...state,
        fee: initFee,
        product: initProduct,
        document: initDoc,
        buyer: initBuyer,
      };
    case CONTRACT_ACTION.SET_DOCUMENT:
      return {
        ...state,
        document: { ...state.document, data: action.payload },
      };
    case CONTRACT_ACTION.SET_REPORT_YEAR:
      return {
        ...state,
        document: { ...state.document, reportYear: action.payload },
      };
    case CONTRACT_ACTION.SET_PROPOSAL:
      return {
        ...state,
        document: { ...state.document, proposal: action.payload },
      };
    case CONTRACT_ACTION.SET_BENEFITS:
      return {
        ...state,
        benefits: action.payload,
      };
    case CONTRACT_ACTION.SET_BENEFITS_CONTRACT:
      return {
        ...state,
        benefitsContract: action.payload,
      };
    case CONTRACT_ACTION.SET_POPUP_LOYALTY:
      return { ...state, popupLoyalty: action.payload };
    default:
      return state;
  }
};
